<template>
    <div id="modul-belajar-2022">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'Modul Pembelajaran' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">Modul Pembelajaran</h3>

        <v-card>
            <v-card-title>
                Daftar Modul
                <v-spacer></v-spacer>
                <v-btn
                    class="align-center text-body-2 blew white--text mr-2"
                    text
                    @click="createModulBelajar()"
                    ><v-icon small class="pr-2">mdi-plus-circle</v-icon>
                    Modul
                </v-btn>
                <v-btn
                    class="align-center text-body-2 blew white--text mr-2"
                    text
                    @click="reportModule()"
                >
                    <v-icon small class="mr-2">mdi-chart-bell-curve</v-icon>
                    Lihat Laporan
                </v-btn>
            </v-card-title>

            <v-card-text class="px-0 py-3 border-top-1">
                <div class="mt-2">
                    <v-row
                        class="d-flex align-center flex-wrap justify-center no-gutters gap-10"
                    >
                        <v-col>
                            <v-autocomplete
                                v-model="grade"
                                height="36px"
                                hide-details
                                placeholder="Kelas"
                                dense
                                clearable
                                outlined
                                :items="gradeList"
                                @change="fetchData()"
                            ></v-autocomplete>
                        </v-col>

                        <v-col>
                            <v-autocomplete
                                v-model="kurikulum"
                                height="36px"
                                hide-details
                                placeholder="Kurikulum"
                                dense
                                clearable
                                outlined
                                :items="[
                                    { text: 'KM', value: 'KM' },
                                    { text: 'K13', value: 'K13' },
                                    { text: 'K13 IPA', value: 'SAINTEK' },
                                    { text: 'K13 IPS', value: 'SOSHUM' },
                                    { text: 'TKA', value: 'TKA' },
                                ]"
                                item-text="text"
                                item-value="value"
                                @change="fetchData()"
                            ></v-autocomplete>
                        </v-col>

                        <v-col>
                            <v-autocomplete
                                v-model="subject"
                                height="36px"
                                hide-details
                                placeholder="Mata Pelajaran"
                                clearable
                                dense
                                outlined
                                :items="mapelList"
                                item-text="nama"
                                item-value="nama"
                                @change="getMapelByName()"
                            ></v-autocomplete>
                        </v-col>

                        <v-col>
                            <v-select
                                v-model="bab"
                                height="36px"
                                hide-details
                                placeholder="Bab"
                                dense
                                clearable
                                outlined
                                :items="topics"
                                item-text="nama"
                                item-value="nama"
                                @change="fetchData()"
                            ></v-select>
                        </v-col>

                        <v-col>
                            <v-select
                                v-model="status"
                                height="36px"
                                hide-details
                                placeholder="Status"
                                dense
                                clearable
                                outlined
                                :items="[
                                    { text: 'Draft', value: 'DRAFT' },
                                    { text: 'Review', value: 'REVIEW' },
                                    { text: 'Publikasi', value: 'PUBLISHED' },
                                ]"
                                item-text="text"
                                item-value="value"
                                @change="fetchData()"
                            ></v-select>
                        </v-col>
                        <v-col>
                            <v-card
                                outlined
                                class="px-4 py-3 text-center"
                                style="border: 2px solid #f0f3f9"
                            >
                                <div class="font-weight-500">Total Modul</div>
                                <div
                                    class="font-weight-700 mt-1"
                                    style="font-size: 24px"
                                >
                                    <v-progress-circular
                                        v-if="isFetchingCount"
                                        indeterminate
                                        size="20"
                                        width="2"
                                        color="blew"
                                    ></v-progress-circular>
                                    <template v-else>
                                        {{ total_modules }}
                                    </template>
                                </div>
                            </v-card>
                        </v-col>
                        <v-col>
                            <v-card
                                outlined
                                class="px-4 py-3 text-center"
                                style="border: 2px solid #f0f3f9"
                            >
                                <div class="font-weight-500">
                                    Modul Terpublikasi
                                </div>
                                <div
                                    class="font-weight-700 mt-1"
                                    style="font-size: 24px"
                                >
                                    <v-progress-circular
                                        v-if="isFetchingCount"
                                        indeterminate
                                        size="20"
                                        width="2"
                                        color="blew"
                                    ></v-progress-circular>
                                    <template v-else>
                                        {{ total_published }}
                                        <span class="font-size-14">
                                            Modul
                                        </span>
                                    </template>
                                </div>
                            </v-card>
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>

            <app-datatable
                :items="Moduls"
                :headers="headers"
                :table-loading="isFetching"
                :hasAction="true"
                :has-custom-pagination="true"
                :custom-pagination-total-items="totalItems"
                :custom-pagination-per-page="pagination.perPage"
                :custom-pagination-total-pages="total_pages"
                :custom-pagination-current-page="pagination.currentPage"
                :custom-pagination-sort-mode="pagination.sortMode"
                v-on:selected="selectedRow = $event"
                v-on:dblClicked="editModulBelajar()"
                v-on:duplicateClicked="duplicateItem()"
                v-on:deleted="
                    dialogConfirm.function = $event;
                    dialogConfirm.title =
                        'Apakah anda yakin akan menghapus Modul Belajar ini?';
                    dialogConfirm.open = true;
                "
                v-on:changePage="
                    pagination = { ...pagination, currentPage: $event }
                "
                v-on:changeSortMode="
                    pagination = { ...pagination, sortMode: $event }
                "
                v-on:doSearch="
                    search = $event;
                    fetchData();
                "
            >
                <template v-slot:no-data>
                    <div class="py-10 text-center">
                        <v-icon size="48" color="grey lighten-1">
                            {{
                                fetchError
                                    ? "mdi-alert-circle-outline"
                                    : "mdi-folder-open-outline"
                            }}
                        </v-icon>
                        <div class="font-weight-bold mt-3 black--text">
                            {{ emptyState.title }}
                        </div>
                        <div class="mt-1">{{ emptyState.subtitle }}</div>
                        <v-btn
                            v-if="fetchError"
                            class="mt-4 blew white--text"
                            depressed
                            small
                            @click="fetchData()"
                        >
                            Coba Lagi
                        </v-btn>
                        <v-btn
                            v-else-if="hasDropdownFilter"
                            class="mt-4"
                            depressed
                            small
                            @click="resetFilter()"
                        >
                            Reset Filter
                        </v-btn>
                        <v-btn
                            v-else-if="!hasActiveFilter"
                            class="mt-4 blew white--text"
                            depressed
                            small
                            @click="createModulBelajar()"
                        >
                            <v-icon small class="pr-2">mdi-plus-circle</v-icon>
                            Tambah Modul
                        </v-btn>
                    </div>
                </template>
            </app-datatable>
        </v-card>

        <v-dialog v-model="dialogConfirm.open" persistent max-width="506px">
            <v-card>
                <v-card-title
                    class="text-h5"
                    style="word-break: break-word !important"
                >
                    {{ dialogConfirm.title }}
                </v-card-title>
                <v-card-text>
                    {{ dialogConfirm.subtitle }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="darkFade"
                        text
                        @click="dialogConfirm.open = false"
                    >
                        Batal
                    </v-btn>
                    <v-btn
                        color="blew"
                        text
                        @click="
                            deleteModulBelajar(dialogConfirm.function);
                            dialogConfirm.open = false;
                        "
                    >
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogConfirm2.open" persistent max-width="506px">
            <v-card>
                <v-card-title
                    class="text-h5"
                    style="word-break: break-word !important"
                >
                    {{ dialogConfirm2.title }}
                </v-card-title>
                <v-card-text>
                    {{ dialogConfirm2.subtitle }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="darkFade"
                        text
                        @click="dialogConfirm2.open = false"
                    >
                        Batal
                    </v-btn>
                    <v-btn
                        v-if="dialogConfirm2.function == 'onDuplicateConfirm'"
                        color="blew"
                        text
                        @click="onDuplicateConfirm"
                    >
                        OK
                    </v-btn>
                    <v-btn
                        v-if="dialogConfirm2.function == 'onDuplicateCancel'"
                        color="blew"
                        text
                        @click="onDuplicateCancel"
                    >
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="showModal"
            transition="dialog-top-transition"
            width="900px"
            persistent
            height="168px"
            @click:outside="
                dialogConfirm2.title = 'Yakin ingin membatalkan duplikasi ?';
                dialogConfirm2.open = true;
                dialogConfirm2.function = 'onDuplicateCancel';
            "
            scrollable
        >
            <v-card>
                <v-card-title width="100%">
                    Detail Duplikat Modul
                    <v-spacer></v-spacer>
                    <v-btn
                        small
                        icon
                        @click="
                            dialogConfirm2.title =
                                'Yakin ingin membatalkan duplikasi ?';
                            dialogConfirm2.open = true;
                            dialogConfirm2.function = 'onDuplicateCancel';
                        "
                        ><v-icon>mdi-close-circle</v-icon></v-btn
                    >
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="py-4 px-6">
                    <v-form ref="duplicateForm" lazy-validation>
                        <v-list-item two-line class="pa-0">
                            <v-list-item-content class="pa-0">
                                <v-list-item-title
                                    class="font-weight-bold pb-2"
                                >
                                    Nama Modul <span class="red--text">*</span>
                                </v-list-item-title>
                                <v-text-field
                                    placeholder="Nama Modul Belajar"
                                    v-model="details.name"
                                    outlined
                                    :rules="[
                                        (v) =>
                                            !!(v && v.trim()) ||
                                            'Nama Modul wajib diisi',
                                    ]"
                                />
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item two-line class="pa-0">
                            <v-list-item-content class="pa-0">
                                <v-list-item-title
                                    class="font-weight-bold pb-2"
                                >
                                    Jenjang <span class="red--text">*</span>
                                </v-list-item-title>

                                <v-radio-group
                                    row
                                    v-model="details.jenjang"
                                    :rules="[
                                        (v) => !!v || 'Jenjang wajib dipilih',
                                    ]"
                                    @change="resetKelas()"
                                >
                                    <v-radio
                                        v-for="item in jenjangList"
                                        v-bind:key="item"
                                        :label="item"
                                        :value="item"
                                        class="jenjang-selection"
                                        active-class="act-radio-btn"
                                    ></v-radio>
                                </v-radio-group>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item
                            two-line
                            class="pa-0"
                            v-if="details.jenjang"
                        >
                            <v-list-item-content class="pa-0">
                                <v-list-item-title
                                    class="font-weight-bold pb-2"
                                >
                                    Kelas <span class="red--text">*</span>
                                </v-list-item-title>
                                <v-input
                                    :value="details.grades"
                                    :rules="[
                                        (v) =>
                                            (v && v.length > 0) ||
                                            'Kelas wajib dipilih minimal satu',
                                    ]"
                                >
                                    <div class="d-inline">
                                        <v-checkbox
                                            v-for="grade in gradesByJenjang[
                                                details.jenjang
                                            ] || []"
                                            :key="grade"
                                            :label="String(grade)"
                                            :value="grade"
                                            v-model="details.grades"
                                            class="pa-2 ma-0 d-inline-flex"
                                            hide-details
                                        />
                                    </div>
                                </v-input>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item two-line class="pa-0">
                            <v-list-item-content class="pa-0">
                                <v-list-item-title
                                    class="font-weight-bold pb-2"
                                >
                                    Status User </v-list-item-title
                                ><v-radio-group
                                    row
                                    v-model="details.status_user"
                                >
                                    <v-radio
                                        id="live_class_type_free"
                                        label="FREE"
                                        value="FREE"
                                        class="jenjang-selection"
                                        active-class="act-radio-btn"
                                    ></v-radio>
                                    <v-radio
                                        id="live_class_type_premium"
                                        label="PREMIUM"
                                        value="PREMIUM"
                                        class="jenjang-selection"
                                        active-class="act-radio-btn"
                                    ></v-radio>
                                </v-radio-group>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item two-line class="pa-0">
                            <v-list-item-content class="pa-0">
                                <v-list-item-title
                                    class="font-weight-bold pb-2"
                                >
                                    Kurikulum <span class="red--text">*</span>
                                </v-list-item-title>
                                <v-input
                                    :value="details.kurikulum"
                                    :rules="[
                                        (v) => !!v || 'Kurikulum wajib dipilih',
                                    ]"
                                >
                                    <div>
                                        <v-checkbox
                                            label="KM"
                                            value="KM"
                                            v-model="details.kurikulum"
                                            class="pa-2 ma-0 d-inline-flex"
                                            hide-details
                                        />
                                        <v-checkbox
                                            label="K13"
                                            value="K13"
                                            v-model="details.kurikulum"
                                            class="pa-2 ma-0 d-inline-flex"
                                            hide-details
                                        />
                                        <v-checkbox
                                            label="K13 IPA"
                                            value="saintek"
                                            v-model="details.kurikulum"
                                            class="pa-2 ma-0 d-inline-flex"
                                            hide-details
                                        />
                                        <v-checkbox
                                            label="K13 IPS"
                                            value="soshum"
                                            v-model="details.kurikulum"
                                            class="pa-2 ma-0 d-inline-flex"
                                            hide-details
                                        />
                                        <v-checkbox
                                            label="TKA"
                                            value="TKA"
                                            v-model="details.kurikulum"
                                            class="pa-2 ma-0 d-inline-flex"
                                            hide-details
                                        />
                                    </div>
                                </v-input>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item two-line class="pa-0">
                            <v-list-item-content class="pa-0">
                                <v-list-item-title
                                    class="font-weight-bold pb-2"
                                >
                                    Semester <span class="red--text">*</span>
                                </v-list-item-title>

                                <v-radio-group
                                    row
                                    v-model="details.semester"
                                    :rules="[
                                        (v) => !!v || 'Semester wajib dipilih',
                                    ]"
                                >
                                    <v-radio
                                        label="Ganjil"
                                        value="GANJIL"
                                        class="jenjang-selection"
                                        active-class="act-radio-btn"
                                    ></v-radio>
                                    <v-radio
                                        label="Genap"
                                        value="GENAP"
                                        class="jenjang-selection"
                                        active-class="act-radio-btn"
                                    ></v-radio>
                                </v-radio-group>
                            </v-list-item-content>
                        </v-list-item>
                    </v-form>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-end">
                    <v-btn
                        text
                        elevation="0"
                        @click="
                            dialogConfirm2.title =
                                'Yakin ingin membatalkan duplikasi ?';
                            dialogConfirm2.open = true;
                            dialogConfirm2.function = 'onDuplicateCancel';
                        "
                        >Batal</v-btn
                    >
                    <v-btn dark color="blew" @click="confirmDuplicate()"
                        >Simpan</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import _ from "lodash";
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import DataTable from "@/modules/global/components/plugins/DataTableModule";
import ItembankService from "@/modules/itembank/services/itembank.js";
import ModulPembelajaranService from "@/modules/modul_belajar_2022/services/modulpembelajaran.js";
import Moment from "moment";

export default {
    name: "live-class",

    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
    },

    data: function () {
        return {
            Moduls: [],
            details: {},
            selectedRow: null,
            isLoading: false,
            isFetching: false,
            isFetchingCount: false,
            fetchError: false,
            // Menandai request terakhir supaya respons lama tidak menimpa data
            fetchRequestId: 0,
            search: null,
            totalItems: 0,
            total_modules: 0,
            total_published: 0,
            kurikulum: "",
            subject: "",
            grade: "",
            bab: "",
            status: "",
            jenjangList: ["SD", "SMP", "SMA"],
            gradesByJenjang: {
                SD: [1, 2, 3, 4, 5, 6],
                SMP: [7, 8, 9],
                SMA: [10, 11, 12],
            },
            gradeList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            topics: [],
            tablekey: 0,
            showModal: false,
            mapelList: JSON.parse(localStorage.getItem("mapels")) || [],
            total_data_per_page: 10,
            total_pages: 0,
            pagination: {
                perPage: 20,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            headers: [
                { text: "No.", value: "no" },
                { text: "Judul", value: "name", width: 300 },
                { text: "Kelas", value: "grades" },
                { text: "Mata Pelajaran", value: "mapel" },
                { text: "Bab", value: "bab" },
                { text: "Sub Bab", value: "subab" },
                { text: "Sub Sub Bab", value: "subsubab" },
                { text: "Nomor Urut", value: "queue" },
                { text: "Status", value: "status" },
                { text: "Jumlah Akses", value: "access" },
                { text: "Aksi", value: "actions" },
            ],
            headersKey: [
                "name",
                "grades",
                "mapel",
                "bab",
                "subab",
                "subsubab",
                "queus",
                "status",
                "access",
            ],
            dialogConfirm: {
                open: false,
                title: null,
                subtitle: null,
                function: null,
            },
            dialogConfirm2: {
                open: false,
                title: null,
                subtitle: null,
                function: null,
            },
        };
    },

    computed: {
        hasDropdownFilter() {
            return !!(
                this.grade ||
                this.kurikulum ||
                this.subject ||
                this.bab ||
                this.status
            );
        },

        hasActiveFilter() {
            return this.hasDropdownFilter || !!this.search;
        },

        emptyState() {
            if (this.fetchError) {
                return {
                    title: "Gagal memuat data modul",
                    subtitle: "Periksa koneksi Anda, lalu coba lagi.",
                };
            }

            if (this.hasActiveFilter) {
                return {
                    title: "Modul tidak ditemukan",
                    subtitle:
                        "Tidak ada modul yang sesuai dengan filter atau pencarian.",
                };
            }

            return {
                title: "Belum ada modul",
                subtitle: "Modul pembelajaran yang dibuat akan tampil di sini.",
            };
        },
    },

    mounted: function () {
        this.fetchData();
        this.fetchCount();
    },

    watch: {
        search() {
            this.fetchData();
        },

        pagination() {
            this.fetchData();
        },
    },

    methods: {
        fetchData: function () {
            var context = this;
            var requestId = ++this.fetchRequestId;
            this.isFetching = true;
            this.fetchError = false;

            if (context.search === null) {
                context.search = "";
            }

            const current_page =
                context.pagination.currentPage > 0
                    ? context.pagination.currentPage - 1
                    : 0;

            this.params = {
                page: current_page,
                sort_by: context.sortBy,
                sort_mode: context.pagination.sortMode,
                size: context.pagination.perPage,
                title: "",
                mapel: "",
                subject: context.subject,
                grade: context.grade,
                bab: context.bab,
                kurikulum: context.kurikulum,
                status: context.status,
                search: context.search,
            };

            ModulPembelajaranService.getListModul(this.params, (result) => {
                if (requestId !== context.fetchRequestId) return;

                context.Moduls = [];
                context.isFetching = false;

                if (!result.success) {
                    context.fetchError = true;
                    context.totalItems = 0;
                    context.total_pages = 0;
                    context.$store.commit("showAlert", {
                        message: "Gagal memuat daftar modul",
                        submessage: result.message,
                        type: "error",
                    });
                    return;
                }

                if (result.success) {
                    context.total_pages = Math.ceil(
                        result.data.total_modules / context.pagination.perPage
                    );
                    context.totalItems = result.data.total_modules;
                    (result.data.list_of_modules || []).forEach(function (
                        group,
                        index
                    ) {
                        var babname = "";
                        if (group.bab !== null) {
                            babname = group.bab.nama;
                        } else {
                            babname = "";
                        }

                        var subbabname = "";
                        if (group.sub_bab !== null) {
                            subbabname = group.sub_bab.nama;
                        } else {
                            subbabname = "";
                        }

                        var subsubbabname = "";
                        if (group.sub_sub_bab !== null) {
                            subsubbabname = group.sub_sub_bab.nama;
                        } else {
                            subsubbabname = "";
                        }
                        var row = {
                            no: index,
                            id: group.id,
                            name: group.name,
                            mapel: group.subject,
                            grades: (group.grades || [])
                                .sort()
                                .toString()
                                .replace(/[\[\]']+/g, ""),
                            status: group.status,
                            bab: babname,
                            subab: subbabname,
                            subsubab: subsubbabname,
                            queue: group.module_order,
                            access: group.total_access,
                        };

                        context.Moduls.push(row);
                        // context.Moduls = _.orderBy(
                        //     context.Moduls,
                        //     "id",
                        //     "desc"
                        // );
                    });
                }
            });
        },

        fetchCount: function () {
            var context = this;
            this.isFetchingCount = true;

            ModulPembelajaranService.getCountModule(function (result) {
                if (result.success) {
                    context.total_modules = result.data.total_count;
                    context.total_published = result.data.total_published;
                }
                context.isFetchingCount = false;
            });
        },

        resetFilter() {
            this.grade = "";
            this.kurikulum = "";
            this.subject = "";
            this.bab = "";
            this.status = "";
            this.topics = [];
            this.fetchData();
        },

        getMapelByName: function () {
            var name = this.subject;
            var found = this.mapelList.find(function (element) {
                return element.nama == name;
            });

            // Bab milik mapel sebelumnya tidak berlaku lagi
            this.bab = "";
            this.topics = [];

            if (!found) {
                this.fetchData();
                return null;
            }

            this.getTopics(found.id);

            return found;
        },

        getTopics(id) {
            var context = this;
            var mapelId = id;

            if (mapelId) {
                mapelId =
                    mapelId.toString().length === 1
                        ? `0${mapelId}`
                        : mapelId.toString();

                ItembankService.getListOfTopic(mapelId, function (result) {
                    context.topics = result.success ? result.data || [] : [];
                });
            }

            context.fetchData();
        },

        resetKelas() {
            this.details.grades = [];
        },

        duplicateItem() {
            var context = this;

            context.details = {};
            context.isLoading = true;
            ModulPembelajaranService.getModulBelajar(
                context.selectedRow.id,
                function (result) {
                    context.isLoading = false;

                    if (!result.success) {
                        context.$store.commit("showAlert", {
                            message: "Gagal memuat detail modul",
                            submessage: result.message,
                            type: "error",
                        });
                        return;
                    }

                    context.details = {
                        ...result.data,
                        name: "Duplikat " + result.data.name,
                        grades: result.data.grades || [],
                    };

                    context.showModal = true;
                    context.$nextTick(function () {
                        if (context.$refs.duplicateForm) {
                            context.$refs.duplicateForm.resetValidation();
                        }
                    });
                }
            );
        },

        confirmDuplicate() {
            if (!this.$refs.duplicateForm.validate()) return;

            this.dialogConfirm2.title =
                "Yakin ingin melakukan duplikasi pada Modul ini ?";
            this.dialogConfirm2.open = true;
            this.dialogConfirm2.function = "onDuplicateConfirm";
        },

        onDuplicateConfirm() {
            const context = this;
            const datafull = this.details;
            context.isLoading = true;

            var babId = 0;
            if (datafull.bab !== null) {
                babId = datafull.bab.id;
            } else {
                babId = 0;
            }

            var subbabId = 0;
            if (datafull.sub_bab !== null) {
                subbabId = datafull.sub_bab.id;
            } else {
                subbabId = 0;
            }

            var subsubbabid = 0;
            if (datafull.sub_sub_bab !== null) {
                subsubbabid = datafull.sub_sub_bab.id;
            } else {
                subsubbabid = 0;
            }

            var usergroupIds = (datafull.user_group || []).map(
                (group) => group.id
            );

            var module = {
                id: datafull.id,
                name: datafull.name,
                subject: parseInt(datafull.subject),
                bab: babId,
                sub_bab: subbabId,
                sub_sub_bab: subsubbabid,
                module_order: datafull.module_order,
                reading_material: datafull.reading_material,
                semester: datafull.semester,
                grades: datafull.grades,
                password: datafull.password,
                jenjang: datafull.jenjang,
                status: datafull.status,
                user_group: usergroupIds,
                status_user: datafull.status_user,
                kurikulum: datafull.kurikulum,
                url: datafull.url,
            };

            ItembankService.duplicateModule(module, (result) => {
                if (result.success) {
                    context.$store.commit("showAlert", {
                        message: `Dupikasi Modul Berhasil!`,
                        type: "success",
                    });
                    context.isLoading = false;
                    context.showModal = false;
                    context.fetchData();
                    context.tableKey++;
                } else {
                    context.$store.commit("showAlert", {
                        message: `Gagal melakukan duplikasi!`,
                        submessage: result.message,
                        type: "error",
                    });
                    context.isLoading = false;
                    context.showModal = false;
                    context.fetchData();
                    context.tableKey++;
                }
            });

            this.selectedRow = null;
            this.dialogConfirm2.open = false;
            this.showModal = false;
        },

        onDuplicateCancel() {
            this.selectedRow = null;
            this.dialogConfirm2.open = false;
            this.showModal = false;
            this.fetchData();
        },

        reportModule() {
            this.$router.push({ path: "/modul-pembelajaran/report" });
        },

        createModulBelajar: function () {
            this.$router.push({ path: "/modul-pembelajaran/form" });
        },

        editModulBelajar: function () {
            var context = this;
            context.isLoading = true;
            var groupId = this.selectedRow.id;

            ModulPembelajaranService.getModulBelajar(
                groupId,
                function (result) {
                    if (result.success) {
                        var ModulBelajar = result.data;
                        context.$store.commit(
                            "modul_pembelajaran_init",
                            ModulBelajar
                        );
                        context.$router.push({
                            path: "/modul-pembelajaran/form",
                            query: { id: groupId },
                        });
                    } else {
                        context.$store.commit("showAlert", {
                            message: "Gagal memuat detail modul",
                            submessage: result.message,
                            type: "error",
                        });
                    }
                    context.isLoading = false;
                }
            );
        },

        deleteModulBelajar: function (tryout) {
            var context = this;
            var groupId = tryout.id;
            context.isLoading = true;

            ModulPembelajaranService.deleteModulPembelajaran(
                groupId,
                function (result) {
                    if (result.success) {
                        context.$store.commit("showAlert", {
                            message: `Berhasil menghapus data!`,
                            type: "success",
                        });
                        context.fetchData();
                        context.fetchCount();
                    } else {
                        context.$store.commit("showAlert", {
                            message: "Gagal menghapus data",
                            submessage: result.message,
                            type: "error",
                        });
                    }
                    context.isLoading = false;
                }
            );
        },
    },
};
</script>



// WEBPACK FOOTER //
// ModulBelajar.vue?166dfa14